import { defineFilterSpec, enumField, multiField, rangeField, text } from '@/lib/api/filter-spec';

import type { DeviceFilterFormValues, DeviceListFilters } from './types';

/** Single declaration of the device list filters. Derives the query-param mapping,
 *  drawer draft seeding/extraction, and the active-filter check — so the empty-vs-undefined
 *  rule lives in one place. Range params keep their identity names (no backend rename). */
const spec = defineFilterSpec<DeviceListFilters, DeviceFilterFormValues>([
  text('search'),
  enumField('deviceType'),
  enumField('status'),
  multiField('categoryIds'),
  multiField('componentIds'),
  rangeField('price'),
  rangeField('installationFee'),
  rangeField('subscriptionPrice'),
  rangeField('available'),
  rangeField('warranty'),
]);

export const toListQuery = spec.toListQuery;
export const toDefaults = spec.toDefaults;
export const toFilters = spec.toFilters;
export const hasActiveFilters = spec.hasActiveFilters;
